import React, { useState, useEffect, useRef, Fragment } from 'react';
import { is_touch_device } from '../utils';

export const R2pGSlider = (props) => {
    const { isBn, styles, r2p } = props;
    const rectHeight = isBn ? 120 : 90;
    const isZoomOut = useRef();
    const isMousedown = useRef();
    const lastOffset = useRef();
    const isButtonDown = useRef();
    const intervalIds = useRef([]);
    const isRun = useRef();
    const isToggle2 = useRef();
    const [isToggle, setIsToggle] = useState(false);
    const [showSlider, setShowSlider] = useState(props?.init !== false);
    const isButtonInside = useRef();
    const sliderEl = useRef();
    const handleEl = useRef();
    const lineContainerEl = useRef();
    const syncObj = useRef(new Object);
    const ps = props.playerSocket;

    const segment = 10;
    const s = styles.locals;
    const player = props.player;

    let onePercentInPixel = useRef();
    let middleHandleHeight = useRef();
    let handleHeight = useRef();
    let diffHeight = useRef();

    function setSliderPos(pos) {
        if (!isToggle2.current) {
            syncToggle();
        }
        moveHandle(pos);
    }

    props.setSliderPosFunc(setSliderPos);
    props.setShowSliderFunc(setShowSlider);

    useEffect(() => {

        if (ps) {
            ps.setSliderSyncFunc(sliderSyncFunc)
        }

        if (typeof props?.init === 'number') {
            setTimeout(_ => setSliderPos(props.init), 0)
        }

        const csrPrefix = r2p.isCsr ? 'csr_' : ''

        if (isBn) {
            !window[csrPrefix + 'r2pSliderBNStyleUse'] && styles.use();
            window[csrPrefix + 'r2pSliderBNStyleUse'] = true;
        }
        else {
            !window[csrPrefix + 'r2pSliderStyleUse'] && styles.use();
            window[csrPrefix + 'r2pSliderStyleUse'] = true;
        }

        setVals();
        setEvents();

        return _ => {
            if (!is_touch_device()) {
                window.removeEventListener('mouseup', windowUp);
                window.removeEventListener('mousemove', windowMove);
            }
        }

    }, []);


    function sliderSyncFunc(d) {
        if (d.syncObj && d.syncObj === syncObj.current) return;
        switch (d.type) {
            case 'toggle': {
                toggle();
                break;
            }
            case 'move': {
                moveHandle(d.data.n);
                break;
            }
            case 'up': {
                windowUp();
                break;
            }

        }
    }

    function setVals() {
        handleHeight.current = 12;//handleEl.current.getBoundingClientRect().height;
        middleHandleHeight.current = handleHeight.current / 2;
        diffHeight.current = rectHeight - handleHeight.current;
        const minimumPercent = 10;
        onePercentInPixel.current = (100 - minimumPercent) / diffHeight.current;
    }

    function setEvents() {
        if (is_touch_device()) {
            sliderEl.current.addEventListener('touchstart', e => { e.preventDefault() });
        }
        else {
            window.addEventListener('mouseup', windowUp);
            window.addEventListener('mousemove', windowMove);
        }
    }

    function windowUp(e) {
        document.body.style.userSelect = '';
        isMousedown.current = false;
        isButtonDown.current = false;
        isRun.current = false;
        while (intervalIds.current.length) {
            var iid = intervalIds.current.pop();
            clearInterval(iid)
        }
    }

    function windowMove(e) {
        !isRun.current && setTimeout(_ => {
            screenYtoRectY(e)
        }, 0);
        if (isMousedown.current) {
            isRun.current = true;
        }
    }

    function screenYtoRectY(e) {
        const y = e.clientY;
        if (!isMousedown.current) return;
        const re = lineContainerEl.current.getBoundingClientRect();
        const rectY = re.top;
        let n = y - rectY - middleHandleHeight.current;
        n = n < 0 ? 0 : n > re.height - handleHeight.current ? re.height - handleHeight.current : n;
        syncMoveHandle(n);
        isRun.current = false;
    }

    function moveHandle(nextTop) {
        let nextApplayTop;

        if (nextTop < 0) {
            nextApplayTop = 0;
        }
        else if (nextTop < diffHeight.current) {
            nextApplayTop = nextTop;
        }
        else {
            nextApplayTop = diffHeight.current;
        }

        handleEl.current.style.top = nextApplayTop + 'px';

        const currentPercent = parseInt(onePercentInPixel.current * nextApplayTop);
        const scaleNum = (1 - currentPercent / 100).toFixed(2)
        player.current.style.transform = 'scale(' + scaleNum + ')';
        lastOffset.current = handleEl.current.offsetTop;
    }

    function syncToggle() {
        if (ps) {
            ps.sliderSync({ type: 'toggle' });
        }
        else {
            toggle();
        }
    }

    function syncMoveHandle(n) {
        if (props.psync.current.notifySliderPos && n >= 0) {
            props.psync.current.notifySliderPos(n);
        }
        if (ps) {
            ps.sliderSync({ type: 'move', data: { n } });
        }
        else {
            moveHandle(n);
        }
    }

    function toggle() {
        isToggle2.current = !isToggle2.current;
        setIsToggle(isToggle2.current);
    }

    function handleMouseDown(e) {
        document.body.style.userSelect = 'none';
        isMousedown.current = true;
        e.stopPropagation();
    }

    function lineContainerDown(e) {
        e = e.nativeEvent;
        isMousedown.current = true;
        var moved = e.offsetY - lastOffset.current - middleHandleHeight.current;
        var nextTop = handleEl.current.offsetTop + moved;
        syncMoveHandle(nextTop);
    }

    function lineTouchMove(e) {
        handleEl.current.style.pointerEvents = 'none';
        e = e.nativeEvent;
        isMousedown.current = true;
        var re = e.target.getBoundingClientRect();
        var offsetY = e.touches[0].pageY - re.top;
        var moved = offsetY - lastOffset.current - middleHandleHeight.current;
        var nextTop = handleEl.current.offsetTop + moved;
        syncMoveHandle(nextTop);
    }

    function buttonDown(direction) {
        isButtonDown.current = true;
        setTimeout(_ => {
            if (isButtonDown.current) {
                const intervalId = setInterval(function () { buttonClick(direction) }, 60)
                intervalIds.current.push(intervalId);
            }
        }, 300);
    }

    function buttonClick(direction) {
        if (!isToggle2.current) {
            syncToggle();
        }
        var moved = (isBn ? 9 : 10) * direction;
        lastOffset.current = lastOffset.current + moved;
        var nextTop = handleEl.current.offsetTop + moved;
        syncMoveHandle(nextTop);
    }

    return (
        <div style={{ display: showSlider ? 'block' : 'none' }} ref={sliderEl} className={`${s['r2p-slider']} ${isToggle && isBn ? s['slider-toggle'] : ''}`} onMouseDown={e => document.body.style.userSelect = 'none'}>
            <div data-qa="zoom-in-itemPage" onClick={_ => buttonClick(-1)} onTouchStart={_ => buttonClick(-1)} onMouseDown={_ => buttonDown(-1)} className={`${s['button']} ${s['plus']}`}></div>
            <div onTouchMove={lineTouchMove} onTouchStart={lineTouchMove} onMouseDown={lineContainerDown} ref={lineContainerEl} className={s['slider-line-container']} style={{ height: isToggle ? rectHeight : 0 }}>
                <div className={s['slider-line']}></div>
                <div onMouseDown={handleMouseDown} ref={handleEl} className={s['r2p-handle']}>
                    <div className={s['dots']}>
                        <div className={s['dot']}></div>
                        <div className={s['dot']}></div>
                        <div className={s['dot']}></div>
                    </div>
                </div>
            </div>
            <div data-qa="zoom-out-itemPage" onClick={_ => buttonClick(1)} onMouseDown={_ => buttonDown(1)} onTouchStart={_ => buttonClick(1)} className={`${s['button']} ${s['minus']}`}></div>
        </div>
    )
}
